<div class="study-session">
  <div class="study-session-header d-flex justify-content-center flex-wrap" >
    <div class="session-title">
      <div class="session-title-label">
        <div class="session-title-label-container">
          <span>{{test.name}}</span>
        </div>
      </div>
      <p>Completed on {{test.date | date: 'MM/dd/yyyy'}}</p>
    </div>
    <div class="session-graph" >
      <div class="responsive-content-desktop">
        <app-doughnut-chart [percent]="test.score" [rightLabel]="true" [innerLabel]="false"
          [cutout]="10" [passed]="test.passed" [height]="45" [width]="60"></app-doughnut-chart>
      </div>
      <div class="responsive-content-mobile">
        <app-progress-bar [attempts]="100" [correct]="test.score"></app-progress-bar>
      </div>
    </div>
    <!-- <a class="btn btn-primary btn-round mr-2 new-session" (click)="startTest(test.id)">
      Create a Custom Checkride Prep Study Session
    </a> -->
  </div>
  <div class="study-session-categories">
    <div class="study-session-categories-header">
      <div *ngFor="let acsCodeDetail of test.acsCodeDetails" class="study-session-categories-body" >
        <div class="details-content">
          <span class="text-size-14 font-weight-700">{{ acsCodeDetail.acsCode }}</span><span class="text-size-14 font-weight-400"> - {{acsCodeDetail.taskElement}}</span>
          <p class="text-color-gray text-size-12"><span class="text-color-gray text-size-12">Area of Operations {{ acsCodeDetail.acsCode.split('.')[1] }}:</span> {{acsCodeDetail.areaOfOperations}}</p>
          <p class="text-color-gray text-size-12"><span class="text-color-gray text-size-12">Task {{ acsCodeDetail.acsCode.split('.')[2] }}:</span> {{acsCodeDetail.task}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
